import Vue from 'vue'
import Router from 'vue-router'

import moduleEntry, { routerRoot } from '@/components'
import NotFound from '@/components/not-found/index'
import ServerError from '@/components/server-error/index'
import organizationEntry from '@/organization'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/wxmini/',
  routes: [
    {
      path: '/404.html',
      component: NotFound
    },
    {
      path: '/502.html',
      component: ServerError
    },
    {
      path: '/write-off-auth/:eventId/:org/:user',
      component: () => import('@/write-off-auth')
    },
    {
      path: '/write-off-wx/:eventId/:org/:user',
      component: () => import('@/write-off-wx')
    },
    {
      path: '/write-off/:activityID/:UID/:awardID',
      component: () => import('@/write-off')
    },
    {
      path: '/write-off-data',
      component: routerRoot,
      children: [
        {
          path: '/',
          component: () => import('@/write-off-data')
        },
        {
          path: '/error',
          name: 'writeOffDataError',
          component: () => import('@/write-off-data/error')
        },
        {
          path: ':orgId',
          component: () => import('@/write-off-data/org')
        },
        {
          path: ':orgId/:activityId',
          component: () => import('@/write-off-data/activity')

        },
        {
          path: ':orgId/:activityId/:uid',
          component: () => import('@/write-off-data/user')
        }
      ]
    },
    {
      path: '/',
      component: routerRoot,
      children: [
        {
          path: ':eventId',
          name: 'event-select',
          component: moduleEntry
        }
      ]
    },
    {
      path: '/org',
      component: routerRoot,
      children: [
        {
          path: ':orgId',
          name: 'organization',
          component: organizationEntry
        }
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})